import { useLocale } from './useLocale';

import { ClientHttpService } from '@services/http/client-http';

export const useHttpService = () => {
  const { country, language } = useLocale();

  return new ClientHttpService({ language, country });
};
